import * as React from 'react';

export const MagnifyingGlassSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.502" height="29.502" viewBox="0 0 29.502 29.502"><path d="M29.5,26.9l-6.123-6.123a12.7,12.7,0,0,0,2.6-7.793A12.908,12.908,0,0,0,12.988,0,12.908,12.908,0,0,0,0,12.988,12.908,12.908,0,0,0,12.988,25.977a12.7,12.7,0,0,0,7.793-2.6L26.9,29.5ZM3.711,12.988a9.187,9.187,0,0,1,9.277-9.277,9.187,9.187,0,0,1,9.277,9.277,9.187,9.187,0,0,1-9.277,9.277A9.187,9.187,0,0,1,3.711,12.988Z"/></svg>
  );
};
